import { addHours, getMinutes, startOfHour, subHours } from 'date-fns';

export interface getDateTimeBoundariesArgs {
  min?: Date;
  max?: Date;
}

interface getDateTimeBoundariesResult {
  firstEventHour: Date;
  lastEventHour: Date;
  scheduleStart: Date;
  scheduleEnd: Date;
}

export const getNextCompleteHour = (time: Date) =>
  getMinutes(time) === 0 ? time : startOfHour(addHours(time, 1));

export const getPrevCompleteHour = (time: Date) =>
  getMinutes(time) === 0 ? time : startOfHour(time);

export const getDateTimeBoundaries = ({
  min,
  max,
}: getDateTimeBoundariesArgs): getDateTimeBoundariesResult => {
  const dateTimeBoundaries = {
    scheduleStart: min,
    scheduleEnd: max,
  } as getDateTimeBoundariesResult;

  if (min && max) {
    dateTimeBoundaries.firstEventHour = getNextCompleteHour(min);
    dateTimeBoundaries.lastEventHour = subHours(max, 1);
  }
  return dateTimeBoundaries;
};
